import { z } from 'zod';

// User Activity Analytics
// NOTE: This schema intentionally excludes PII (firstName, lastName, email)
// because deleteAccount performs a hard delete. Adding PII fields here would
// cause failures when analytics reference deleted users.

export const UserActivityAnalyticsSchema = z.object({
    userId: z.string(),
    appOpens: z.number(),
    completedQuizzes: z.number(),
    quizResultViews: z.number(),
    articlesOpened: z.object({
        total: z.number(),
        unique: z.number(),
    }),
    videosOpened: z.object({
        total: z.number(),
        unique: z.number(),
    }),
    campusResourcesOpened: z.object({
        total: z.number(),
        unique: z.number(),
    }),
});

export const UserActivityAnalyticsResponseSchema = z.object({
    users: z.array(UserActivityAnalyticsSchema),
    totalUsers: z.number(),
});

// Article Analytics

export const ArticleAnalyticsItemSchema = z.object({
    articleId: z.string(),
    articleName: z.string(),
    moduleNumber: z.number().optional(),
    assignmentType: z.enum(['general', 'bucket-one', 'bucket-two']),
    totalViews: z.number(),
    uniqueViews: z.number(),
    likes: z.number(),
    dislikes: z.number(),
});

export const ArticleAnalyticsResponseSchema = z.object({
    articles: z.array(ArticleAnalyticsItemSchema),
});

// Video Analytics

export const VideoAnalyticsItemSchema = z.object({
    videoId: z.string(),
    videoName: z.string().optional(),
    moduleNumber: z.number().optional(),
    bucketNumber: z.number().optional(),
    totalViews: z.number(),
    uniqueViews: z.number(),
    averageViewsPerUser: z.number(),
});

export const VideoAnalyticsResponseSchema = z.object({
    videos: z.array(VideoAnalyticsItemSchema),
});

// Campus Resource Analytics

export const CampusResourceAnalyticsItemSchema = z.object({
    resourceId: z.string(),
    resourceName: z.string(),
    totalViews: z.number(),
    uniqueViews: z.number(),
    averageViewsPerUser: z.number(),
});

export const CampusResourceAnalyticsResponseSchema = z.object({
    resources: z.array(CampusResourceAnalyticsItemSchema),
});

// Overall Analytics Summary

export const AnalyticsSummarySchema = z.object({
    totalUsers: z.number(), // All users with activity data (including deleted)
    activeUsers: z.number(), // Current active user accounts
    totalAppOpens: z.number(),
    totalQuizzesCompleted: z.number(),
    totalArticleViews: z.number(),
    totalVideoViews: z.number(),
    totalCampusResourceViews: z.number(),
});
